import { useSelector } from 'react-redux';
import React from 'react';
import { commonState } from '../../../app/base/commonSlice';

interface TranslateProps {
  en?: string | null;
  bn?: string | null;
  styles?: React.CSSProperties;
  className?: string;
}

function Translate({ en, bn, styles, className }: TranslateProps) {
  const { language } = useSelector(commonState);

  const content = language === 'en' ? en : bn;

  return (
    <span
      className={className}
      style={styles}
      dangerouslySetInnerHTML={{
        __html: content || '', // Use either English or Bengali content
      }}
    />
  );
}

export default React.memo(Translate);
